<template>
	<b-col cols="3">
		<h4 class="mt-2">Health & Resolve</h4>
		<b-table-simple responsive small bordered striped table-class="mb-0">
			<b-tbody>
				<b-tr>
					<b-td><strong>HP</strong> <small class="text-muted">Health</small></b-td>
					<b-td class="table-cell-blank"></b-td>
					<b-td class="text-right">{{totalHP}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>SP</strong> <small class="text-muted">Stamina</small></b-td>
					<b-td class="table-cell-blank"></b-td>
					<b-td class="text-right">{{totalSP}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>RP</strong> <small class="text-muted">Resolve</small></b-td>
					<b-td class="table-cell-blank"></b-td>
					<b-td class="text-right">{{totalRP}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		...mapGetters('character/status',[
			'totalHP',
			'totalSP',
			'totalRP',
		])
	}
}
</script>

<style scoped>
	.table-cell-blank {
		width: 4em;
	}
</style>